<template>
    <div id="page-user-list">

        <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
            <div class="vx-row">
                <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                <label class="text-sm opacity-75">Role</label>
                <v-select :options="roleOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="roleFilter" class="mb-4 md:mb-0" />
                </div>
                <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                <label class="text-sm opacity-75">Status</label>
                <v-select :options="employeeStatus" label="status" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="statusFilter" class="mb-4 md:mb-0" />
                </div>
                <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                <label class="text-sm opacity-75">Verified</label>
                <v-select :options="isVerifiedOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="isVerifiedFilter" class="mb-4 sm:mb-0" />
                </div>
                <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                <label class="text-sm opacity-75">Department</label>
                <v-select :options="departments" label="departmentName" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="departmentFilter" />
                </div>
            </div>
        </vx-card>

        <div class="vx-card p-6">
            <div class="flex flex-wrap items-center">
                <!-- <vs-dropdown vs-trigger-click class="cursor-pointer">
                    <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ usersData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : usersData.length }} of {{ usersData.length }}</span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>
                    <vs-dropdown-menu>

                    <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                        <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                        <span>20</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                        <span>25</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                        <span>30</span>
                    </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown> 
             </div> -->

                <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
            </div>
            <!-- AgGrid Table -->
            <ag-grid-vue
                ref="agGridTable"
                :components="components"
                :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="usersData"
                rowSelection="multiple"
                colResizeDefault="shift"
                :animateRows="true"
                :floatingFilter="true"
                :pagination="true"
                :paginationPageSize="paginationPageSize"
                :suppressPaginationPanel="true"
                :enableRtl="$vs.rtl">
            </ag-grid-vue>

            <vs-pagination
                :total="totalPages"
                :max="7"
                v-model="currentPage" />
            <vs-button type="gradient" color="primary" @click="promptAddNewEmployee()"  icon-pack="feather" icon="icon-plus">Add</vs-button>

        </div>

         <!-- ADD NEW EMPLOYEE/USERS -->
            <vs-prompt
                class="email-compose"
                title="Register Employee"
                accept-text= "Submit"
                @accept="onAddEmployee"
                :is-valid="validForm"
                :active.sync="activePromptNewEmployee">
                <vx-card title="Fill-out the following information">


                    <div class="vx-row mb-3">
                        <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                            <span  class="text-sm">Employee Code</span><span style="color:red">*</span>
                            <vs-input class="w-full" v-validate="'required'" name="employee code" v-model="registerNewEmployee.employeeCode" placeholder="Employee Code" />
                            <span class="text-danger text-sm" v-show="errors.has('employee code')">{{ errors.first('employee code') }}</span>

                        </div>
                    </div>
                
                    <div class="vx-row mb-3">
                        <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-4">
                            <span  class="text-sm">First Name</span><span style="color:red">*</span>
                            <vs-input class="w-full" v-validate="'required'" name="first name" v-model="registerNewEmployee.firstName" placeholder="First Name" />
                            <span class="text-danger text-sm" v-show="errors.has('first name')">{{ errors.first('first name') }}</span>

                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col  sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-4">
                            <span  class="text-sm">Last Name</span><span style="color:red">*</span>
                            <vs-input class="w-full" v-validate="'required'" name="last name" v-model="registerNewEmployee.lastName" placeholder="Last Name" />
                            <span class="text-danger text-sm" v-show="errors.has('last name')">{{ errors.first('last name') }}</span>

                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col  sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-4">
                            <span  class="text-sm">Middle Name</span><span style="color:red">*</span>
                            <vs-input class="w-full" v-validate="'required'" name="middle name" v-model="registerNewEmployee.middleName" placeholder="Middle Name" />
                            <span class="text-danger text-sm" v-show="errors.has('middle name')">{{ errors.first('middle name') }}</span>

                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-4">
                            <span  class="text-sm">Email</span><span style="color:red">*</span>
                            <vs-input class="w-full" v-validate="'email'" name="email" v-model="registerNewEmployee.email" placeholder="Email" />
                            <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>

                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full mb-2" >
                            <span  class="text-sm">Company Name</span><span style="color:red">*</span>
                            <v-select  v-validate="'required'" name="Company Name" class="w-full"  v-model="tenantName" label="name" :options="getAllTenant"  placeholder="Please Select"/>
                            <span class="text-danger text-sm" >{{ errors.first('step-1.Company Name') }}</span>
                        </div>
                    </div>
            
                </vx-card>
            </vs-prompt>
    </div>
</template>


<script>

import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

import moment from 'moment'

import CellRendererVerified from './cell-renderer/CellRendererVerified.vue'
import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'
import CellRendererDepartment from './cell-renderer/CellRendererDepartment.vue'
import CellRendererLink from './cell-renderer/CellRendererLink.vue'

export default {
    components: {
        AgGridVue,
        vSelect,

        CellRendererVerified,
        CellRendererStatus,
        CellRendererDepartment,
        CellRendererLink
    },
    created() {
        this.$vs.loading()
        
        const payload = {
                    pageNumber: 1,
                    pageSize: -1,
                    sortBy: 'CreatedOn',
                    sortOrder: 'Desc',
        }
        // this.$store.dispatch('tenants/getAllTenants', payload)
        const data = {
            pageNumber: -1,
            pageSize: -1
        }

        this.$store.dispatch('hrms/getAllEmployee', data)
            .then(res => { this.$vs.loading.close() })
            .catch(err => { console.error(err) })
        this.$store.dispatch('lookup/getAllDepartment').catch(err => { console.error(err) })
        this.$store.dispatch('tenants/getAllTenants', payload).catch(err => { console.error(err) })
        
        
            
        
    },
    computed: {
        usersData () {
            return this.$store.state.hrms.allEmployee
        },
        // employeeInformation:{
        //     get() { return this.$store.state.hrms.employeeInformation },
        //     set(value) { this.$store.dispatch('hrms/getAllInformation', value)}
        // },
        // employeeIdentification: {
        //     get() { return this.$store.state.hrms.employeeIdentification },
        //     set(value) { }
        // },
        paginationPageSize () {
            if (this.gridApi) return this.gridApi.paginationGetPageSize()
            else return 10
        },
        totalPages () {
            if (this.gridApi) return this.gridApi.paginationGetTotalPages()
            else return 0
        },
        currentPage: {
            get () {
                if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
                else return 1
            },
            set (val) {
                this.gridApi.paginationGoToPage(val - 1)
            }
        },
        getAllTenant() {
            return this.$store.state.tenants.tenants
        },
        tenantName: {
            get() { return this.$store.getters['tenants/tenantName'](this.registerNewEmployee.tenantsId)  },
            set(obj) { this.registerNewEmployee.tenantsId = obj.tenantsId }
        },
        employeeStatus() {
            return this.$store.state.lookup.employeeStatus
        },
        departments(){
            return  this.$store.state.lookup.getAllDepartment
        },
        validForm(){

        }   
       
    },
    watch: {
        // roleFilter (obj) {
        // this.setColumnFilter('role', obj.value)
        // },
        // statusFilter (obj) {
        // this.setColumnFilter('status', obj.value)
        // },
        // isVerifiedFilter (obj) {
        // const val = obj.value === 'all' ? 'all' : obj.value === 'yes' ? 'true' : 'false'
        // this.setColumnFilter('is_verified', val)
        // },
        // departmentFilter (obj) {
        // this.setColumnFilter('department', obj.value)
        // }
    },
    data() {
        return {
            activePromptNewEmployee: false,
            registerNewEmployee: {},

            // Filter Options
            roleFilter: { label: 'All', value: 'all' },
            roleOptions: [
                { label: 'All', value: 'all' },
                { label: 'Admin', value: 'admin' },
                { label: 'User', value: 'user' },
                { label: 'Staff', value: 'staff' }
            ],

            statusFilter: { status: 'All', value: 'all' },
            // statusOptions: [
            //     { label: 'All', value: 'all' },
            //     { label: 'Active', value: 'active' },
            //     { label: 'Deactivated', value: 'deactivated' },
            //     { label: 'Blocked', value: 'blocked' }
            // ],

            isVerifiedFilter: { label: 'All', value: 'all' },
            isVerifiedOptions: [
                { label: 'All', value: 'all' },
                { label: 'Yes', value: 'yes' },
                { label: 'No', value: 'no' }
            ],

            departmentFilter: { departmentName: 'All', value: 'all' },
            // departmentOptions: [
            //     { label: 'All', value: 'all' },
            //     { label: 'Sales', value: 'sales' },
            //     { label: 'Development', value: 'development' },
            //     { label: 'Management', value: 'management' }
            // ],

            searchQuery: '',
      
      
             // AgGrid
            gridApi: null,
            gridOptions: {},
            defaultColDef: {
                sortable: true,
                resizable: true,
                suppressMenu: true
            },

            columnDefs: [
                {
                headerName: 'ID',
                field: 'id',
                width: 125,
                filter: true,
                checkboxSelection: true,
                headerCheckboxSelectionFilteredOnly: true,
                headerCheckboxSelection: true
                },
                {
                headerName: 'Username',
                field: 'userName',
                filter: true,
                width: 210,
                cellRendererFramework: 'CellRendererLink'
                },
                {
                headerName: 'Email',
                field: 'email',
                filter: true,
                width: 225
                },
                {
                headerName: 'Employee Number',
                field: 'employeeCode',
                filter: true,
                width: 200
                },
                {
                headerName: 'First Name',
                field: 'firstName',
                filter: true,
                width: 200
                },
                {
                headerName: 'Last Name',
                field: 'lastName',
                filter: true,
                width: 200
                },
                {
                headerName: 'Country',
                field: 'employeeInformation.country',
                filter: true,
                width: 150
                },
                {
                headerName: 'Role',
                field: 'roles',
                filter: true,
                width: 150
                },
                {
                headerName: 'Status',
                field: 'employeeInformation.employeeStatus',
                filter: true,
                width: 150,
                cellRendererFramework: 'CellRendererStatus'
                },
                {
                headerName: 'Verified',
                field: 'emailConfirmed',
                filter: true,
                width: 125,
                cellRendererFramework: 'CellRendererVerified',
                cellClass: 'text-center'
                },
                {
                headerName: 'Department',
                field: 'employeeIdentification.departmentId',
                filter: true,
                width: 150,
                cellRendererFramework: 'CellRendererDepartment'
                },
                {
                headerName: 'Actions',
                field: 'transactions',
                width: 150,
                // cellRendererFramework: 'CellRendererActions'
                }
            ],

        // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererDepartment
      }
        }
    },
    
    methods: {
        setColumnFilter (column, val) {
        const filter = this.gridApi.getFilterInstance(column)
        let modelObj = null

        if (val !== 'all') {
            modelObj = { type: 'equals', filter: val }
        }

        filter.setModel(modelObj)
        this.gridApi.onFilterChanged()
        },
        resetColFilters () {
        // Reset Grid Filter
        this.gridApi.setFilterModel(null)
        this.gridApi.onFilterChanged()

        // Reset Filter Options
        this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'All', value: 'all' }

        this.$refs.filterCard.removeRefreshAnimation()
        },
        updateSearchQuery (val) {
        this.gridApi.setQuickFilter(val)
        },
        promptAddNewEmployee() {
            this.activePromptNewEmployee = true
        },
        onAddEmployee(){
            // this.$vs.loading()

            this.registerNewEmployee.firstName =  this.titleCase(this.registerNewEmployee.firstName)
            this.registerNewEmployee.lastName =  this.titleCase(this.registerNewEmployee.lastName)
            this.registerNewEmployee.middleName =  this.titleCase(this.registerNewEmployee.middleName)
            this.generateRandomPassword()
            
            console.log(this.registerNewEmployee)
            this.$store.dispatch('hrms/registerUser', this.registerNewEmployee)
                .then((res) => {
                    this.$vs.loading.close()
                    this.$alert('', 'Registration Successful', 'success')
                })
                .catch((err) => { 
                    this.$vs.loading.close()
                    this.$alert(err, 'Registration Failed', 'danger')
                    console.log(err) 
                })
        },
        generateRandomPassword() {

            var lastName = this.registerNewEmployee.lastName.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '').replace(/\s/g, '').toLowerCase();
            const year = new Date().getFullYear()
            this.registerNewEmployee.password = lastName + year + this.registerNewEmployee.employeeCode.toLowerCase()

            
            // Math.random().toString(36).substr(2, 8); //6 is the length of the string
            // var characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
            // var result = ""
            // var charactersLength = characters.length;

            // for ( var i = 0; i < 9 ; i++ ) {
            //     result += characters.charAt(Math.floor(Math.random() * charactersLength));
            // }
            // this.registerNewEmployee.password = result

            console.log(this.registerNewEmployee.password)
        },
        titleCase(str) {
          return str
              .split(' ')
              .map((word) => word[0].toUpperCase() + word.slice(1).toLowerCase())
              .join(' ');
      }
  },
  mounted () {
    this.gridApi = this.gridOptions.api

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
  },

}
</script>

<style>

</style>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>